import { createBrowserHistory, createMemoryHistory } from "history";

import { isWebEnv } from "./isWebEnv";

export const historyInstance = isWebEnv()
  ? createBrowserHistory()
  : createMemoryHistory();
